import {
  IDeltaHedgeExeCommonSearchParam,
  IErrorReport,
} from "../../Interfaces/deltaHedgeExe";
import TableTemplate from "../TableTemplate/tableTemplate";
import { CommonTableUI } from "../TableTemplate/common";
import { getErrorTable } from "../../Requests/deltaHedgeExe";

interface IProps {
  searchParams: IDeltaHedgeExeCommonSearchParam;
  onFetchComplete?: (page?: number) => void;
  refreshFlag?: boolean;
}

const ErrorTable = ({
  searchParams,
  onFetchComplete,
  refreshFlag,
}: IProps) => {
  return (
    <TableTemplate<IDeltaHedgeExeCommonSearchParam, IErrorReport>
      TableUI={({ reports, onAction }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          refreshFlag={refreshFlag}
        />
      )}
      getDataTable={getErrorTable}
      searchParameters={searchParams}
      onFetchComplete={onFetchComplete}
    />
  );
};
export default ErrorTable;
